export default __webpack_public_path__ + "static/media/chrome.77d3621b.png";